import { Maybe } from "@/domains/common/types";
import { AudioRecordingModelData } from "@/store/audio-recordings/types";
import { OptimisticSyncUpdate, SyncUpdateValue } from "@/store/sync/types";

export type AudioRecordingIndexData = {
  associated_note_id: string | null;
  associated_client_id: string | null;
  trashed_at: string | null;
  locally_created_at: string | null;
};

export class AudioRecordingIndexes {
  private data: SyncUpdateValue<AudioRecordingModelData> | undefined;

  constructor({
    remoteData,
    optimisticUpdates,
  }: {
    remoteData: Maybe<SyncUpdateValue<AudioRecordingModelData>>;
    optimisticUpdates: OptimisticSyncUpdate<AudioRecordingModelData>[];
  }) {
    this.data =
      (optimisticUpdates.at(-1)?.value as SyncUpdateValue<AudioRecordingModelData>) || remoteData;
  }

  get associated_note_id(): string | null {
    return this.data?.model_data.associated_note_id ?? null;
  }

  get associated_client_id(): string | null {
    return this.data?.model_data.associated_client_id ?? null;
  }

  get trashed_at(): string | null {
    return this.data?.model_data.trashed_at ?? null;
  }

  get locally_created_at(): string | null {
    return this.data?.model_data.locally_created_at ?? null;
  }

  get indexes(): AudioRecordingIndexData {
    return {
      associated_note_id: this.associated_note_id,
      associated_client_id: this.associated_client_id,
      trashed_at: this.trashed_at,
      locally_created_at: this.locally_created_at,
    };
  }
}
